import React from 'react'
import {SzButton} from '@suezenv/react-theme-components';
import {useTranslation} from 'react-i18next';

interface IError {
  title: string;
  description?: string
  img?: string;
  refreshPage: () => void;
  navigateToAuthentication: () => void;
  showRefreshButton: boolean;
  showAtlasAuthButton: boolean;
  contactAdmin: boolean;
}

const ErrorComponent: React.FC<IError> = (props: IError) => {
  const {t} = useTranslation();
  const {description, title, img} = props;
  return (
    <div className="h-75 row  align-items-center justify-content-center">
      <div className="col-auto text-center">
        <h1 className="title display-1 text-center"> {title}  </h1>
        {props.img && <img className="text-center mb-4" src={img} alt=""/>}
        <h1 className="title text-center">
          {description ? (<div dangerouslySetInnerHTML={{__html: description}}></div>) : t("error_message")}
          {props.contactAdmin && <div>{t("contact_admin_label")}</div>}
        </h1>

        <div className="row align-items-center justify-content-center mt-4">
          {props.showRefreshButton && (
            <div className="col-4">
              <SzButton onClick={props.refreshPage}>{t("refresh_label")}</SzButton>
            </div>
          )}
          {props.showAtlasAuthButton && (
            <div className="col-4">
              <SzButton onClick={props.navigateToAuthentication}>{t("auth_login_atlas")}</SzButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default ErrorComponent